import { Component, ElementRef, ViewChild } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent {
    
    @ViewChild('menuButton') menuButton!: ElementRef;

    @ViewChild('mobileMenuButton') mobileMenuButton!: ElementRef;
    
    constructor(public layoutService: LayoutService, public el: ElementRef,private router: Router) {}

    activeItem!: number;

    get mobileTopbarActive(): boolean {
        return this.layoutService.state.topbarMenuActive;
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }


    onMobileTopbarMenuButtonClick() {
        this.layoutService.onTopbarMenuToggle();
    }
    logout(){
        this.router.navigate(['/account/login']);
        // clear local storage
        localStorage.clear();
    }
}
